<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5g2trz/tc-custom/9781459254138.jpg?1705019893977" alt="This image is the cover for the book 5 Bodies to Die For, Body Movers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">5 Bodies to Die For, Body Movers
      </h1>
      <p class="bookDescription body article font2">
        <b>A debutante-turned-department store clerk hides out from a serial killer at her high school sweetheart’s place in this romantic mystery.</b><br/><br/>The Charmed Killer is on the loose in Atlanta and Carlotta Wren is caught up in the terror—especially when her body-moving side business brings her dangerously close to the action.<br/><br/><i>And then</i> . . .<br/><br/>She’s forced to take refuge in her former fiancé’s house—much to the chagrin of other interested parties . . .<br/><br/>Her brother Wesley begins to behave as if he has his own death wish . . .<br/><br/>And someone close to her is implicated in the mass murders.<br/><br/>Meanwhile, Carlotta can’t shake the feeling that danger is dogging her seemingly cursed family—and that the serial killer’s exploits are starting to get personal. . . .<br/><br/><b>Praise for <i>5 Bodies to Die For</i></b><br/><br/>“Bond’s latest mystery brims with suspense while also offering a liberal peppering of wickedly funny dialogue and situations as well as a Persian cat whose goal in life is to make Carlotta miserable. This standout is part of a terrific series librarians will want to have in full.” —<i>Booklist</i>, Starred Review
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stephanie Bond
      </h2>
      
      <p class="authorDescription body article">Stephanie Bond grew up in eastern Kentucky, but traveled to distant lands through Harlequin romance novels. Years later, the writing bug bit her, and once again she turned to romance. Her writing has allowed her to travel in person to distant lands to teach workshops and promote her novels. She&rsquo;s written more than forty projects for Harlequin, including a romantic mystery series called Body Movers. To learn more about Stephanie Bond and her novels, visit www.stephaniebond.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?44107258